{
  "name": "catalogo",
  "version": "1.5.0",
  "author": {
    "name": "Antonio Capuano",
    "email": "antonio.capuano@dplatforms.it"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve:local": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build-dev": "ng build --configuration=dev --output-hashing=all",
    "build-qta": "ng build --configuration=qta --output-hashing=all",
    "build-prod": "ng build --configuration=prod --output-hashing=all",
    "build-all": "ng build --configuration=dev --output-hashing=all && ng build --configuration=qta --output-hashing=all && ng build --configuration=prod --output-hashing=all"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.27.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.7",
    "bootstrap-icons": "^1.13.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.1",
    "@angular/cli": "^19.2.27",
    "@angular/compiler-cli": "^19.0.0",
    "@types/bootstrap": "^5.2.10",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.6.2"
  }
}
